import { Stack, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import Dimens from '../../themes/dimens';

type TextAreaProps = TextFieldProps;

const TextArea = (props: TextAreaProps) => {
	const { sx, multiline, minRows, fullWidth, label, ...rest } = props;

	const defaultSx = (theme: Theme) => ({
		'& .MuiInputBase-input': {
			...theme.typography.paragraph,
			color: theme.palette.textPrimary.main,
		},
		'& .MuiInputBase-input::placeholder': {
			color: theme.palette.textPlaceholder.main,
			opacity: 1,
		},
	});

	const mergedSx = [
		defaultSx,
		...(Array.isArray(sx) ? sx
		: sx ? [sx]
		: []),
	];

	const isFullWidth = fullWidth ?? true;
	const ariaLabelFromProps = rest['aria-label'];
	const computedAriaLabel =
		typeof ariaLabelFromProps === 'string' ? ariaLabelFromProps
		: typeof label === 'string' ? label
		: undefined;

	return (
		<Stack
			spacing={Dimens.spacingXs}
			alignItems='flex-start'
			sx={{ width: isFullWidth ? '100%' : 'auto' }}
		>
			{label && <Typography variant='labelSm'>{label}</Typography>}
			<TextField
				{...rest}
				aria-label={computedAriaLabel}
				multiline={multiline ?? true}
				minRows={minRows ?? 4}
				fullWidth={isFullWidth}
				sx={mergedSx}
			/>
		</Stack>
	);
};

export default TextArea;
